
<div [ngClass]="{'technician' : isTechnician()}">

  @if(!isAftermarket() && salesCompetitionData() && salesCompetitionData().IsActive) {
      <div class="d-flex justify-content-center bg-primary align-items-center text-warning rounded p-3 me-3">
          <span class="salesCompetitionText">{{salesCompetitionData().Text}}</span><button (click)="openSalesCompetition()" class="btn btn-sm btn-white" target="_blank" title="{{salesCompetitionData().AlternativeText}}">{{salesCompetitionData().ButtonText}}</button>
      </div>
  }

  <!-- Marketing banner -->
  @if(notificationsBannerStr() && !isAftermarket()) {
      <div class="w-99 text-end p-2 bg-secondary mt-2 border rounded">
        @if(!showNotificationsBanner()) {
          <div class="pointer-hover text-sm" (click)="showNotificationsBanner.set(true)">visa banner +</div>
        } @else {
          <div class="pointer-hover text-sm" (click)="showNotificationsBanner.set(false)">dölj banner -</div>
        }
      </div>
      @if(!showNotificationsBanner()) {
          <div class="w-100 border-top"></div>
      } @else {
          <div class="d-flex bg-white p-2 mb-2 border rounded w-99" [innerHTML]="trustAsHtml(notificationsBannerStr())"></div>
      }
  }

</div> <!-- /#page-content-wrapper -->

<ng-template #marketingNotificationTemplate>
  <marketing-notification [notification]="note" [html]="html" [salesCompetitionData]="salesCompetitionData()" [modalId]="marketingModalId"></marketing-notification>
</ng-template>

<ng-template #marketingPopupTemplate>
  <marketing-popup [popup]="popup" [modalId]="marketingPopupModalId"></marketing-popup>
</ng-template>
